import React from 'react';
// To make HTTP request
import axios from 'axios';


// Material UI Imports
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';


//Route Imports
import { Link } from 'react-router-dom';

// Assets imports
import '../styles/Login.css';
import logo from '../assets/lexia_logo_960x160.jpg';


const theme = createMuiTheme({
  palette: {
    primary: {
      main: process.env.REACT_APP_PRIMARY_COLOR,
    },
  },
  typography: {
    useNextVariants: true,
  },
});

const paperStyle = {
  // Css to center the paper
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // General styles for paper
  width: "60%",
  height: "auto",
  padding: "2em",
  textAlign: 'center',
};

const buttonStyle = {
  marginTop: 20,
  marginLeft: 10,
  float: "Right",
  width: 100
};

class UpdatePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    this.get_user_by_token()
  }

  get_user_by_token() {
    var apiBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL + '/api/password/check/' + this.props.match.params.token;

    // check another name for this
    var temp = this;

    axios.get(apiBaseUrl).then(function (response) {
      if (response.data.status === "ok") {
        console.log("All ok " + response.data.user_id)
        temp.setState({ userId: response.data.user_id })

      }
      else {
        alert(response.data.message)
        temp.props.history.push("/");
      }
    }).catch(function (error) {
      alert(error)
      console.log(error);
    });

  }

  handleClick(event) {
    // var apiBaseUrl = process.env.REACT_APP_LOGIN_URI;
    var apiBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL + '/passwords/' + this.state.userId;

    // check another name for this
    var temp = this;


    axios.put(apiBaseUrl, {
      password: {
        password: this.state.password,
        password_confirmation: this.state.passwordConfirmation,
        reset_password_token: this.props.match.params.token
      }
    }).then(function (response) {

      if (response.data.status === "ok") {
        console.log("Password Created")
        alert(response.data.message)
        temp.props.history.push("/");


      }
      else {
        alert(response.data.message)
      }
    }).catch(function (error) {
      alert(error)
      console.log(error);
    });
  }


  render() {

    return (
      <div className="Login">
        <MuiThemeProvider theme={theme}>
          <Paper style={paperStyle} elevation={3}>
            <img src={logo} className="Login-logo" alt="logo" />
            <h1 className="Login-title">Create a New Password</h1>
            <p>Please enter your password and password confirmation</p>
            <div>
              <div>
                <TextField
                  variant="outlined"
                  type="password"
                  margin="normal"
                  placeholder="Enter your Password"
                  label="Password"
                  onChange={(event) => this.setState({ password: event.target.value })}
                  fullWidth={true}
                />
              </div>
              <div>
                <TextField
                  variant="outlined"
                  type="password"
                  placeholder="Enter your Password Confirmation"
                  label="Password Confirmation"
                  onChange={(event) => this.setState({ password: event.target.value })}
                  fullWidth={true}
                />
              </div>
              <div>
                {/* <Button variant="contained" label="Submit" primary={"true"} style={style} onClick={this.handleClick.bind(this)} /> */}
                <Button variant="contained"
                  color='secondary'
                  style={buttonStyle}
                  // onClick={this.props.history.goBack} />
                  // containerElement={<Link to="/login" />} 
                  component={Link}
                  to="/login"
                >cancel
                  </Button>
                <Button variant="contained"
                  color='primary'
                  style={buttonStyle}
                  onClick={(event) => this.handleClick(event)} >
                  Send
                  </Button>
              </div>
            </div>
          </Paper>
        </MuiThemeProvider>
      </div>
    )
  }

}



export default UpdatePassword;


// WEBPACK FOOTER //
// src/components/UpdatePassword.js